import React from 'react';
import HistoryList from "../HistoryList/HistoryList";

export const RecordsHistory = () => {
  return <HistoryList />;
}
